import { useState, useRef } from "react";
import styles from "./styles.module.scss";

interface MusicCardProps {
  id: number;
  url: string;
  onDelete: (id: number) => void;
}

export const MusicCard: React.FC<MusicCardProps> = ({ id, url, onDelete }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };


  return (
    <div className={styles.cardMusica}>
      <div className={styles.header}>
        <button className={styles.deleteBtn} onClick={() => onDelete(id)}>🗑️</button>
      </div>

      <audio
        ref={audioRef}
        controls
        src={url}
        className={styles.audio}
        onEnded={() => setIsPlaying(false)}
      />
    </div>
  );
};
